import { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { SplashScreen } from "./components/SplashScreen";
import { HomeDelta } from "./components/HomeDelta";
import { UnidadInteligencia } from "./components/UnidadInteligencia";
import { BunkerPage } from "./components/BunkerPage";

// import { GlobalStorm } from "./components/GlobalStorm";

export default function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = useCallback(() => {
    setShowSplash(false);
  }, []);

  return (
    <BrowserRouter>
      <div
        className="size-full relative"
        style={{
          minHeight: "100vh",
          background:
            "radial-gradient(circle at center, rgba(120,0,255,0.12) 0%, rgba(0,0,0,0.96) 70%)"
        }}
      >
        {/* <GlobalStorm /> */}

        <Routes>
          <Route path="/" element={<HomeDelta />} />
          <Route path="/unidad-inteligencia" element={<UnidadInteligencia />} />
          <Route path="/bunker" element={<BunkerPage />} />
        </Routes>

        {showSplash && (
          <SplashScreen onFinish={handleSplashFinish} />
        )}
      </div>
    </BrowserRouter>
  );
}
